import { render, staticRenderFns } from "./gameTab.vue?vue&type=template&id=24815eea"
import script from "./gameTab.vue?vue&type=script&lang=js"
export * from "./gameTab.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/app.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24815eea')) {
      api.createRecord('24815eea', component.options)
    } else {
      api.reload('24815eea', component.options)
    }
    module.hot.accept("./gameTab.vue?vue&type=template&id=24815eea", function () {
      api.rerender('24815eea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/game/gameTab.vue"
export default component.exports